import React from "react"
import { SensorsLivePage } from "../modules/Sensors/SensorsLivePage"

export function SensorsTab() {
	return <SensorsLivePage />
}
